import { ReactNode } from 'react';
import { useAtomsToHydrate } from '@/hooks/useAtomsToHydrate';
import { useSection } from '@/hooks/useSection';
import { Section } from '@/types/generic';

/* This wrapper is so that we await being in the correct section before hydrating the atoms */
const ChildrenWrapperToHydrate = ({ children }: { children: ReactNode }) => {
  useAtomsToHydrate();

  return children;
};

export const SectionWrapper = ({ children, section }: { children: ReactNode; section: Section }) => {
  const isSectionSet = useSection(section);

  return isSectionSet && <ChildrenWrapperToHydrate>{children}</ChildrenWrapperToHydrate>;
};
